(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumi-card-style-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lumi-card-style-swatches')) {
    customElements.define('lumi-card-style-swatches', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.card = this.closest('.product-card-wrapper');
        if (!this.card) return;
        this.card.classList.add('lumi-style-card');
        const media = this.card.querySelector('.card__media .media');
        media?.classList.remove('media--hover-effect', 'lumi-secondary-image-active');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.lumi-card-style-swatch');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.querySelectorAll('.lumi-card-style-swatch').forEach((swatch) => {
            swatch.setAttribute('aria-pressed', String(swatch === button));
          });
          const image = this.card.querySelector('.card__media .media > img');
          if (image) {
            image.removeAttribute('srcset');
            image.src = button.dataset.imageSrc;
            image.alt = button.dataset.imageAlt;
          }
          this.card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
            link.href = button.dataset.variantUrl;
          });
          this.card.querySelectorAll('.quick-add [data-product-url]').forEach((control) => {
            control.dataset.productUrl = button.dataset.variantUrl;
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
